// Canonical bucket/slider ordering for the assessment underlyings (plan §3.6).
// Unknown codes sort after these, alphabetical order preserved by the caller.
export const BUCKET_ORDER = [
  'US2Y',
  'US10Y',
  'EU10Y',
  'GB10Y',
  'SPY',
  'EURUSD',
  'USDJPY',
  'USO',
];

// Display labels for the 11 portfolio checks returned by GET risk/
// (pm.api pm/assessment/services/live_risk.py).
export const PORTFOLIO_CHECK_LABELS: { [name: string]: string } = {
  total_gross_cash_m: 'Total Gross ($m)',
  bond_gross_m: 'Bond Gross ($m)',
  net_dv01_k_bp: 'Net DV01 ($k/bp)',
  gross_dv01_k_bp: 'Gross DV01 ($k/bp)',
  equity_gross_delta_m: 'Equity Gross Delta ($m)',
  equity_net_delta_m: 'Equity Net Delta ($m)',
  fx_gross_m: 'FX Gross ($m)',
  same_direction_usd_m: 'Same-Direction USD ($m)',
  oil_gross_m: 'Oil Gross ($m)',
  option_premium_m: 'Option Premium ($m)',
  stress_loss_m: 'Stress Loss ($m)',
};
